export default __webpack_public_path__ + "static/media/branding_xl.c38a4c90.jpg";